const LOCAL_HOSTNAMES = new Set(["localhost", "127.0.0.1"]);

function inferBackendUrl() {
  if (typeof window === "undefined") {
    return "http://localhost:2000";
  }

  const { protocol, hostname, host } = window.location;
  if (LOCAL_HOSTNAMES.has(hostname)) {
    return "http://localhost:2000";
  }

  return `${protocol}//${host}`;
}

const envBackendUrl = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/+$/, "");

export const BACKEND_URL = envBackendUrl || inferBackendUrl();
export const API_URL = `${BACKEND_URL}/api`;
